import React from "react";

interface IProps {
  isShowLogout: boolean;
  setIsShowLogout: () => void;
}

const ModalConfirmLogout: React.FC<IProps> = ({
  isShowLogout,
  setIsShowLogout,
}) => {
  const Cookies = require("js-cookie");
  
  // Debug log
  console.log('ModalConfirmLogout render:', { isShowLogout });

  return (
    <div
      className={`logout-modal ${isShowLogout ? "active" : ""}`}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        display: isShowLogout ? 'flex' : 'none',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
        background: 'rgba(0, 0, 0, 0.85)',
        backdropFilter: 'blur(5px)',
        animation: isShowLogout ? 'modalFadeIn 0.3s ease-out' : 'none'
      }}
    >
      <div
        style={{
          position: 'relative',
          width: '90%',
          maxWidth: '420px',
          background: 'radial-gradient(circle at 20% 0%, rgba(248, 113, 113, 0.28) 0%, transparent 55%), radial-gradient(circle at 80% 100%, rgba(249, 115, 22, 0.24) 0%, transparent 60%), linear-gradient(145deg, #220000 0%, #3b0000 35%, #7f1d1d 70%, #9a3412 100%)',
          border: '2px solid rgba(248, 113, 113, 0.9)',
          borderRadius: '24px',
          padding: '32px 24px',
          boxShadow: '0 0 40px rgba(248, 113, 113, 0.6), 0 0 80px rgba(249, 115, 22, 0.45), inset 0 0 40px rgba(127, 29, 29, 0.7)',
          fontFamily: "'Courier New', monospace"
        }}
      >
        {/* Close Button */}
        <button
          onClick={setIsShowLogout}
          style={{
            position: 'absolute',
            top: '16px',
            right: '16px',
            background: 'rgba(248, 113, 113, 0.16)',
            border: '2px solid #f97316',
            borderRadius: '50%',
            color: '#fed7aa',
            fontSize: '20px',
            fontWeight: '500',
            cursor: 'pointer',
            width: '40px',
            height: '40px',
            minWidth: '40px',
            minHeight: '40px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: 'all 0.2s ease',
            opacity: 0.7
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = 'rgba(248, 113, 113, 0.35)';
            e.currentTarget.style.borderColor = '#fb923c';
            e.currentTarget.style.color = '#fff7ed';
            e.currentTarget.style.opacity = '1';
            e.currentTarget.style.boxShadow = '0 0 20px rgba(239, 68, 68, 0.4)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = 'rgba(239, 68, 68, 0.2)';
            e.currentTarget.style.borderColor = '#ef4444';
            e.currentTarget.style.color = '#ef4444';
            e.currentTarget.style.opacity = '0.7';
            e.currentTarget.style.boxShadow = 'none';
          }}
        >
          ×
        </button>

        {/* Icon */}
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            marginBottom: '20px'
          }}
        >
          <div
            style={{
              width: '64px',
              height: '64px',
              background: 'conic-gradient(from 220deg, #fee2e2, #fed7aa, #f97316, #b91c1c)',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: '0 0 30px rgba(248, 113, 113, 0.7)',
              border: '2px solid rgba(248, 113, 113, 0.9)'
            }}
          >
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
              <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9" 
                    stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
        </div>

        {/* Title */}
        <h2
          style={{
            textAlign: 'center',
            color: '#fee2e2',
            fontSize: '24px',
            fontWeight: 'bold',
            marginBottom: '12px',
            letterSpacing: '2px',
            textShadow: '0 0 18px rgba(248, 113, 113, 0.9)',
            textTransform: 'uppercase'
          }}
        >
          ĐĂNG XUẤT
        </h2>

        {/* Message */}
        <p
          style={{
            textAlign: 'center',
            color: '#ffffff',
            fontSize: '16px',
            marginBottom: '32px',
            lineHeight: '1.5',
            fontWeight: '500',
            fontFamily: "'Courier New', monospace"
          }}
        >
          Bạn có chắc chắn muốn đăng xuất khỏi tài khoản?
        </p>

        {/* Buttons */}
        <div style={{ display: 'flex', gap: '12px' }}>
          {/* Cancel Button */}
          <button
            onClick={setIsShowLogout}
            style={{
              flex: 1,
              padding: '14px 12px',
              background: 'linear-gradient(90deg, #4b5563, #1f2937)',
              border: '2px solid rgba(148, 163, 184, 0.8)',
              borderRadius: '12px',
              color: '#ffffff',
              fontSize: '14px',
              fontWeight: 'bold',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              fontFamily: "'Courier New', monospace",
              textTransform: 'uppercase',
              letterSpacing: '0.5px',
              boxShadow: '0 0 20px rgba(15, 23, 42, 0.7)',
              whiteSpace: 'nowrap',
              minWidth: '140px'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'scale(1.05)';
              e.currentTarget.style.boxShadow = '0 0 30px rgba(15, 23, 42, 0.9)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'scale(1)';
              e.currentTarget.style.boxShadow = '0 0 20px rgba(15, 23, 42, 0.7)';
            }}
          >
            [ HỦY BỎ ]
          </button>

          {/* Confirm Logout Button */}
          <button
            onClick={() => {
              try { Cookies.remove("access_token"); } catch (e) {}
              try { localStorage.removeItem("access_token"); } catch (e) {}
              try { localStorage.removeItem("user_info"); } catch (e) {}
              try { localStorage.removeItem("user_avatar"); } catch (e) {}
              try { localStorage.removeItem("title_img"); } catch (e) {}
              try { localStorage.removeItem("NH_PAGE"); } catch (e) {}
              setIsShowLogout();
              // Force redirect to login page and clear all states
              window.location.href = "/login";
            }}
            style={{
              flex: 1,
              padding: '14px 12px',
              background: 'linear-gradient(90deg, #dc2626, #ea580c)',
              border: '2px solid rgba(248, 113, 113, 0.95)',
              borderRadius: '12px',
              color: '#ffffff',
              fontSize: '14px',
              fontWeight: 'bold',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              fontFamily: "'Courier New', monospace",
              textTransform: 'uppercase',
              letterSpacing: '0.5px',
              boxShadow: '0 0 24px rgba(248, 113, 113, 0.7)',
              whiteSpace: 'nowrap',
              minWidth: '140px'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'scale(1.05)';
              e.currentTarget.style.boxShadow = '0 0 32px rgba(249, 115, 22, 0.9)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'scale(1)';
              e.currentTarget.style.boxShadow = '0 0 24px rgba(248, 113, 113, 0.7)';
            }}
          >
            [ ĐĂNG XUẤT ]
          </button>
        </div>
      </div>

      {/* CSS Animation */}
      <style
        dangerouslySetInnerHTML={{
          __html: `
            @keyframes modalFadeIn {
              from { 
                opacity: 0; 
                transform: scale(0.95) translateY(20px);
              }
              to { 
                opacity: 1; 
                transform: scale(1) translateY(0);
              }
            }
          `,
        }}
      />
    </div>
  );
};

export default ModalConfirmLogout;
